import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
var StripePaymentLink = function (_a) {
    var invoice = _a.invoice;
    var t = useTranslation().t;
    if (invoice.paidAt)
        return React.createElement("span", null, t('labels.paid'));
    if (!invoice.hasPaymentIntent)
        return React.createElement("span", null, "-");
    return (React.createElement(Link, { to: "/roaster/invoices/".concat(invoice.id, "/start_stripe_payment") }, t('links.payFromHere')));
};
export default StripePaymentLink;
